import React, { useState } from 'react';
import { Modal, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ImageGallery from 'react-image-gallery';
import { images } from './images';
import pic1 from '../../images/Night1.jpg';
import pic2 from '../../images/Media1.jpg';
import pic3 from '../../images/Bedroom4-1.jpg';
import pic4 from '../../images/Garage2.jpg';
import pic5 from '../../images/Pool5.jpg';
import pic6 from '../../images/Kitchen1.jpg';

import './Gallery.scss';

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0)

	const handleModalOpen = () => {
		setOpen(true)
	}

	const handleModalClose = () => {
		setOpen(false)
  } 
  
  const handleIndex = (i) => {
    setIndex(i)
  }

	const body = (
		<div className="gallery-modal">
      <IconButton className="gallery-modal-button" onClick={handleModalClose}>
        <CloseIcon fontSize="large" />
      </IconButton>
      <div className="gallery-modal-slide">{index + 1} / 47</div>
      <div className="gallery-modal-table">
        <table>
          <tbody>
            <tr>
              <td className="images">
                <ImageGallery 
                  items={images} 
                  showFullscreenButton={false}
                  showPlayButton={false}
                  startIndex={index}
                  onBeforeSlide={(i) => handleIndex(i)}
                />
              </td>
            </tr>
            <tr><td className="description">{images[index].description}</td></tr>
          </tbody>
        </table>
      </div>
		</div>
  )

  return (
    <div className="gallery">
      <h1>Gallery</h1>
      <table className="gallery-table">
        <tbody>
          <tr>
            <td colSpan="2"><img alt="Poolside Bonfire" src={pic1} onClick={() => { handleIndex(4); handleModalOpen() }} /></td>
            <td colSpan="2"><img alt="Poolside Bonfire" src={pic2} onClick={() => { handleIndex(13); handleModalOpen() }} /></td>
          </tr>
          <tr>
              <td><img  src={pic3} alt="Star Wars Room" onClick={() =>{ handleIndex(34); handleModalOpen() }} /></td>
              <td><img src={pic4} alt="Princess Room" onClick={() => { handleIndex(17); handleModalOpen() }} /></td>
              <td><img src={pic5} alt="Floorplan" onClick={() => { handleIndex(11); handleModalOpen() }}/></td>
              <td>
                <div className="overlap" onClick={() => { handleIndex(20); handleModalOpen() }}><p>42+</p></div>
                <img src={pic6} alt="Street View" />
              </td>
          </tr>
          <tr><td colSpan="4" className="virtual-tour-button" onClick={handleModalOpen}>TAKE A VIRTUAL TOUR OF OUR HOME</td></tr>
        </tbody>
      </table>
      {/* <iframe 
        title="resortInfo"
        height="600" 
        width="100%" 
        src="https://my.matterport.com/show/?m=h4fQrFVYb9U&brand=0" 
        frameBorder="0" 
        allowFullScreen
      >
      </iframe> */}
      <Modal disablePortal open={open} onClose={handleModalClose}>
				{body}
			</Modal>
    </div>
  )
}

export default Gallery;